// MotoristaPacotes.tsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {t} from "../../../lang/index"

interface Pacote {
  id: number;
  titulo: string;
  precoBase?: number;
  fotoUrls?: string[];
}

interface Props {
  pacotes: Pacote[];
  baseUrl: string;
}

interface ResumoAvaliacao {
  media: number;
  total: number;
}

const MotoristaPacotes: React.FC<Props> = ({ pacotes, baseUrl }) => {
  const [resumos, setResumos] = useState<Record<number, ResumoAvaliacao>>({});

  useEffect(() => {
    const fetchResumos = async () => {
      if (!pacotes || pacotes.length === 0) return;

      try {
        const responses = await Promise.all(
          pacotes.map((p) =>
            axios.get(`${baseUrl}/avaliacoes/pacote/${p.id}/resumo`).then((res) => res.data)
          )
        );

        const map: Record<number, ResumoAvaliacao> = {};
        pacotes.forEach((p, idx) => {
          map[p.id] = responses[idx];
        });

        setResumos(map);
      } catch (err) {
        console.error("Erro ao buscar resumos:", err);
      }
    };

    fetchResumos();
  }, [pacotes, baseUrl]);

  if (!pacotes || pacotes.length === 0)
    return <p>{t("home.driverModal.noPackages")}</p>;

  return (
    <div className="row g-2 mt-3">
      {pacotes.map((pacote) => (
        <div key={pacote.id} className="col-6 col-md-4">
          <Link
            to={`/flight-details/${pacote.id}`}
            className="text-decoration-none text-dark"
          >
            <div className="card h-100">
              {/* Foto */}
              <img
                src={
                  pacote.fotoUrls && pacote.fotoUrls.length > 0
                    ? `${baseUrl}${pacote.fotoUrls[0]}`
                    : "/assets/img/no-image.png"
                }
                className="card-img-top"
                alt={pacote.titulo}
                style={{ height: "120px", objectFit: "cover" }}
              />

              <div className="card-body p-2">
                {/* Título */}
                <h6 className="text-truncate mb-2">{pacote.titulo}</h6>

                {/* Preço + Avaliação lado a lado */}
                <div className="d-flex justify-content-between align-items-center">
                  {/* Preço */}
                  {pacote.precoBase !== undefined && (
                    <p className="mb-0 text-primary fw-medium">
                      R$ {pacote.precoBase.toFixed(2)}
                    </p>
                  )}

                  {/* Avaliação */}
                  {resumos[pacote.id] ? (
                    resumos[pacote.id].total > 0 ? (
                      <div className="d-flex align-items-center">
                        <i className="isax isax-star1 text-warning me-1 fs-14" />
                        <span className="badge badge-warning badge-xs text-gray-9 fs-10 fw-medium me-1 p-1">
                          {resumos[pacote.id].media.toFixed(1)}
                        </span>
                        <small className="text-muted">({resumos[pacote.id].total})</small>
                      </div>
                    ) : (
                      <small className="text-muted">{t("home.driverModal.noReviews")}</small>
                    )
                  ) : (
                    <small className="text-muted">{t("home.driverModal.loading")}</small>
                  )}
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default MotoristaPacotes;